import * as React from 'react';
import DocumentHeader from '../../../components/DocumentHeader';
import DocumentWrapper from '../../../components/DocumentWrapper';
import FormEditingHandler from '../../../containers/FormEditingHandler';
import DocumentCreationButton from '../../../components/DocumentCreationButton';
import { FormContextProvider, HistoryContextProvider } from '../../../containers/FormContextHandler';
import AriaSymptomsForm from './Form';
import AriaSymptomsHistory from './HistoryRowData';
import { useAppSelector } from 'Store/index';
import { sortPartialDate } from 'neuro-utils';
import { useIntl } from 'react-intl';

const AriaSymptoms = ({ documents }: IOwnProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });
  const mriDocsWithAria = (useAppSelector(s => s.documents.sortedAndMergedDocuments)?.filter(
    d =>
      d._type === 'mri' &&
      (((d as IMRI).ariaE?.finding && (d as IMRI).ariaE?.finding !== 'no') || (d as IMRI).ariaH?.finding === 'yes'),
  ) ?? []) as IMRI[];

  const latestMriWithAria = mriDocsWithAria?.toSorted((m1, m2) => sortPartialDate(m2.date, m1.date))[0];
  const latestAriaSymptoms = documents?.toSorted((a1, a2) => sortPartialDate(a2.date, a1.date))[0];

  return (
    <FormEditingHandler name="ariaSymptoms" documents={documents}>
      {(editing, startEdit, formData, view): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            headerId={'ariaSymptoms.title'}
            editing={editing || view?.viewing}
            editButtons={
              <div>
                <DocumentCreationButton
                  name="ariaSymptoms"
                  text={'general.new'}
                  onClick={startEdit({})}
                  disabled={sortPartialDate(latestMriWithAria?.date, latestAriaSymptoms?.date) === -1}
                  disabledTooltip={<>{fm('ariaSymptoms.disabledNew')}</>}
                />
              </div>
            }
          />
          {!view?.viewing && !editing && documents ? (
            <HistoryContextProvider context={{ documents, startEdit, view }}>
              <AriaSymptomsHistory />
            </HistoryContextProvider>
          ) : undefined}
          {view?.viewing || editing ? (
            <FormContextProvider context={{ documents: documents || [], formData, editing, view }}>
              <AriaSymptomsForm />
            </FormContextProvider>
          ) : undefined}
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents?: IAriaSymptoms[];
}

export default AriaSymptoms;
